/**
 * Dev: same-origin via Vite proxy. Prod: derive from VITE_API_URL or window origin.
 */
export function buildRealtimeWsUrl(token: string): string {
  const encoded = encodeURIComponent(token);

  if (import.meta.env.DEV) {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${window.location.host}/api/realtime/ws?token=${encoded}`;
  }

  const raw = (import.meta.env.VITE_API_URL || window.location.origin).replace(/\/+$/, '');
  const httpBase = raw.endsWith('/api') ? raw.slice(0, -4) : raw;
  const wsBase = httpBase.replace(/^http/i, (match: string) =>
    match.toLowerCase() === 'https' ? 'wss' : 'ws'
  );
  return `${wsBase}/api/realtime/ws?token=${encoded}`;
}
